export const mobile = 'screen and (max-width: 767px)'

export const mobileCSS = (css: string) => `@media ${mobile} { ${css} }`
